module.exports = __webpack_public_path__ + "/login_ui/img/cn-03403229c1adffd4dd4e162705c29088.svg";